export async function stickyButtons() {
    const buttons = document.querySelectorAll('[data-sticky-button]');

    if (buttons.length) {
        const { initStickyButtons } = await import(/* webpackMode: "lazy" */ './inc/sticky-buttons.async.js');

        initStickyButtons(buttons);
    }
}
